<template>
  <body class="body-container">
  HRモンスター　パスワード変更画面　セキュリティ上、定期的にパスワード変更をお願いしております。
  <b-field label="現在のパスワード" style="text-align: left;">
    <b-input v-model="oldPassword"
             class="buefy-input-password input-field"
             type="password"
             icon="lock"
             minlength="8"
             password-reveal>
    </b-input>
  </b-field>
  <b-field label="新しいパスワード" style="text-align: left;">
    <b-input v-model="newPassword"
             class="buefy-input-password input-field"
             type="password"
             icon="lock"
             minlength="8"
             maxlength="20"
             password-reveal>
    </b-input>
  </b-field>
  <b-field>
    <a id="PS-0002" class="button is-primary" @click="setProfile({'password': newPassword, 'old_password': oldPassword}, 'user')">変更する</a>
  </b-field>
    <a href="/">TOPに戻る</a>
  </body>
</template>
<script>
import { mapState } from 'vuex'
import BasicModal from '@/components/Modals/BasicModal'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'PasswordResetPeriodical',
  componentName: 'PasswordResetPeriodical',
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user', 'error', 'success']),
    ...mapState('mediapool', ['images'])
  },
  data() {
    return{
      COMPONENT_NAME: 'PasswordResetPeriodical',
      oldPassword: '',
      newPassword: '',
      isDataLogout: false,
      isNotShow: false,
      company: {
        company_name: null,
        company_url: null
      },
      isLoading: true
    };
  },
  created () {
    if (this.$route.query.cid) {
      this.$store.dispatch('auth/getCompanyAny', this.$route.query.cid)
        .then((d) => {
          this.company = d
          this.isLoading = false
        })
    } else {
      this.isLoading = false
    }
  },
  watch: {
    success: function () {
      if (this.success) {
        // Email、名前、パスワードを変えた時は強制ログアウトする
        if (this.isDataLogout) {
          alert('変更を反映するためログアウトします。\n再度ログイン操作を行ってください。')
          // 設定変更後にlogoutすると認証切れで401が返りログアウトできない
          // ここではローカルストレージのトークン情報をクリアすることで、
          // ブラウザのログイン状態を強制的にログアウト状態にしてログイン画面に遷移する
          document.location.href = '/login'
          this.$store.dispatch('auth/forceLogout')
        } else {
          this.$buefy.snackbar.open({
            message: 'セーブしました！',
            type: 'is-success',
            position: 'is-top'
          })
        }
      }
    },
    error: function () {
      if (this.error) {
        this.$buefy.snackbar.open({
          message: '正常に保存が完了しませんでした。再読み込みしてください。',
          type: 'is-danger',
          position: 'is-top'
        })
      }
    }
  },
  methods: {
    setProfile (data, type) {
      // password_set_dateをデータに追加
      const now = new Date().toISOString();
      const updatedData = {
      ...data,
      password_set_date: now
      };
      this.sendControlLog('パスワード強制変更', '強制画面にて、「変更する」ボタンをクリックした。')
      if (data.username || data.email || (data.password && data.old_password)) {
        // 変更後ログアウトが必要
        this.isDataLogout = true
      }
      this.$store.dispatch('auth/setProfile',{
      data: updatedData,
      type: type
      })
      this.oldPassword = ''
      this.newPassword = ''
    },
  }
}
</script>
<style scoped>
.body-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
}

.b-field {
  width: 100%;
  max-width: 400px;
  margin-bottom: 20px;
}

.button, .action-button {
  width: 100%;
  max-width: 400px;
}
.input-field {
  width: 100%;
  max-width: 400px;
}

/* ここからレスポンシブデザインのスタイル */
@media (max-width: 768px) {
  .b-field, .button, .action-button {
    max-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PasswordReset/PasswordResetPeriodical.vue